export default __webpack_public_path__ + "static/media/checkbox-checked-big.419116a5.svg";